import axios from "axios";
import { BaseUrl} from './base_url';

const baseURL = `${BaseUrl}/api`
// const baseURL = `${BaseUrl}`
const ApiService = axios.create({
    baseURL
})

export default ApiService